/**
 * Mystery Pack Free Gift - add/remove logic for collection.mystery-pack template
 * - Injects _mystery_pack_qualifying property when adding from this page
 * - Adds free gift when qualifying product is added
 * - Removes free gift when last qualifying product is removed
 */
(function () {
  const QUALIFYING_PROP = '_mystery_pack_qualifying';
  const GIFT_PROP = '_mystery_pack_gift';

  function getConfig() {
    const el = document.getElementById('mystery-pack-config');
    if (!el) return null;
    try {
      const config = JSON.parse(el.textContent);
      return config.enabled && config.freeGiftVariantId ? config : null;
    } catch (e) {
      return null;
    }
  }

  function isMysteryPackPage() {
    return document.body.classList.contains('template--collection-mystery-pack') ||
           document.body.classList.contains('template--collection-glow-up');
  }

  // Inject qualifying property into add-to-cart forms on submit (capture phase)
  function setupPropertyInjection() {
    document.addEventListener('submit', function (evt) {
      const form = evt.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (!isMysteryPackPage()) return;

      // Add hidden input for property (will be in FormData when product-form reads it)
      let input = form.querySelector('input[name="properties[' + QUALIFYING_PROP + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + QUALIFYING_PROP + ']';
        input.value = '1';
        form.appendChild(input);
      }
    }, true);
  }

  async function addFreeGift(variantId) {
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer?.getSectionsToRender?.()?.map((s) => s.id) || ['cart-drawer', 'cart-icon-bubble'];

    const response = await fetch(window.Shopify?.routes?.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { [GIFT_PROP]: '1' }
        }],
        sections: sections,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();
    if (!data.status && cartDrawer && data.sections) {
      cartDrawer.renderContents(data);
    }
  }

  async function removeFreeGift(lineIndex) {
    const cartItems = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    if (cartItems && typeof cartItems.updateSingleLineItemQuantity === 'function') {
      await cartItems.updateSingleLineItemQuantity(lineIndex, 0);
    }
  }

  async function checkAndUpdateFreeGift() {
    const config = getConfig();
    if (!config) return;

    try {
      const res = await fetch(window.Shopify?.routes?.root + 'cart.js');
      const cart = await res.json();

      const hasQualifying = cart.items.some((item) => item.properties?.[QUALIFYING_PROP]);
      const giftItem = cart.items.find(
        (item) => item.variant_id === config.freeGiftVariantId && item.properties?.[GIFT_PROP]
      );

      if (hasQualifying && !giftItem) {
        await addFreeGift(config.freeGiftVariantId);
      } else if (!hasQualifying && giftItem) {
        const index = cart.items.findIndex((i) => i.key === giftItem.key);
        if (index !== -1) {
          await removeFreeGift(index + 1);
        }
      }
    } catch (e) {
      console.error('[Mystery Pack] Error checking free gift:', e);
    }
  }

  function setupCartUpdateListener() {
    if (typeof subscribe !== 'function') return;

    subscribe('cart-update', function () {
      if (!getConfig()) return;
      setTimeout(checkAndUpdateFreeGift, 400);
    });
  }

  function init() {
    if (!isMysteryPackPage() || !getConfig()) return;
    setupPropertyInjection();
    setupCartUpdateListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
